import { lazy } from "react";

export { MY_SURVEYS_PATH } from "./my-surveys-path";
export const MySurveysPage = lazy(() => import("./my-surveys"));
